import React from 'react';
import { useSetLanguage } from '~/hooks/i18nHooks';
import { LogoImg, LogoWithTextArImg, LogoWithTextImg } from '~/img';
import { ImgProps } from '~/img/utils';

interface Props {
  withtext?: boolean | 'true';
}

const LogoI18n = (props: ImgProps & Props) => {
  const { withtext = false } = props;
  const { language } = useSetLanguage();

  if (withtext) {
    return language === 'ar' ? <LogoWithTextArImg {...props} /> : <LogoWithTextImg {...props} />;
  }

  return language === 'ar' ? <LogoWithTextArImg style={{ height: 25 }} {...props} /> : <LogoImg {...props} />;
};

export default LogoI18n;
